module.exports = __webpack_public_path__ + "static/media/Mana Acoustics reference rack.b0e1f6fb.jpg";